export default __webpack_public_path__ + "46d678cc3a48ce2c02fd70d1a7a1758b.jpg";